import { Button, ButtonProps, Icon } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";
import { IconType } from "react-icons";
import { Tooltip } from "../ui/tooltip";

interface Props extends ButtonProps {
  label: string;
  icon?: IconType;
  tooltipContent?: string;
}

function CustomButton({
  icon,
  colorPalette,
  label,
  tooltipContent,
  ...props
}: Props) {
  const colors = useThemeColors();
  return (
    <Tooltip content={tooltipContent || label}>
      <Button
        colorPalette={colorPalette || colors.schoolAccent.primary}
        {...props}
      >
        {icon && <Icon as={icon} />}
        {label}
      </Button>
    </Tooltip>
  );
}

export default CustomButton;
